// extracted by mini-css-extract-plugin
export var content = "_4x-3";
export var list = "_4x-4";
export var settingsContent = "_4x-7";
export var settingsPanel = "_4x-8";
export var state = "_4x-6";
export var triggerBadge = "_4x-2";
export var triggerButton = "_4x-1";
export var triggerShell = "_4x-0";
export var unreadDot = "_4x-5";